var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var BodyPart = (function() {

    var _requestBodyPart = function(bodyPart) {
      return {
        type: constants.REQUEST_BODYPART
      };
    }

    var _receiveBodyPart = function(data) {
      return {
        type: constants.RECEIVE_BODYPART,
        data: data.bodypart[0],
        receivedAt: Date.now()
      };
    }

    var _fetchBodyPart = function(bodyPart) {
      return function (dispatch) {
        dispatch(_requestBodyPart());
        return api.get('/proxy/v1/bodyparts?friendlyurl=' + bodyPart).then(function (response) {
          return response;
        }).then(function (data) {
          return dispatch(_receiveBodyPart(data));
        }).catch(function(error){
          if(error.response){
            dispatch(commonActions.setGenericResponseError('', error.response));
          }else{
            dispatch(commonActions.setGenericError('', error.message));
          }
        });
      };
    }

    var _shouldFetchBodyPart = function(state, friendlyUrl) {
      var bodyPart = state.bodyPart;
      if (Object.keys(bodyPart).length === 0) {
        return true;
    } else if (bodyPart.items && bodyPart.items.friendlyUrl === friendlyUrl) {
        return false;
      } else {
        return true;
      }
    }

    var _fetchBodyPartIfNeeded = function(bodyPart) {
      return function(dispatch, getState) {
        if (_shouldFetchBodyPart(getState(), bodyPart)) {
          return dispatch(_fetchBodyPart(bodyPart))
        }
      }
    }

    return {
        requestBodyPart: _requestBodyPart,
        receiveBodyPart: _receiveBodyPart,
        fetchBodyPart: _fetchBodyPart,
        shouldFetchBodyPart: _shouldFetchBodyPart,
        fetchBodyPartIfNeeded: _fetchBodyPartIfNeeded
    }
})();

module.exports = BodyPart;



// WEBPACK FOOTER //
// ./src/common/modules/education/actions/bodyPart.js